// components/Navbar2.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';

const Navbar2 = ({ title, backPath, styleType, onStyleTypeChange }) => {
  const navigate = useNavigate();

  return (
    <nav className="flex items-center justify-between p-6 border-b">
      <div className="text-2xl font-bold text-black">
        {title}
      </div>
      
      <div className="flex items-center space-x-4">
        {/* Style type buttons - only shown when onStyleTypeChange is provided */}
        {onStyleTypeChange && (
          <div className="flex space-x-2 mr-2">
            <button
              onClick={() => onStyleTypeChange('predefined')}
              className={`px-3 py-1 rounded-md ${
                styleType === 'predefined' 
                  ? 'bg-black text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Predefined
            </button>
            <button
              onClick={() => onStyleTypeChange('custom')}
              className={`px-3 py-1 rounded-md ${
                styleType === 'custom' 
                  ? 'bg-black text-white' 
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              Custom
            </button>
          </div>
        )}
        
        <button
          onClick={() => navigate(backPath)}
          className="text-gray-600 hover:text-black transition-colors duration-200"
        >
          <XCircle size={24} />
        </button>
      </div>
    </nav>
  );
};

export default Navbar2;